import React, { useEffect, useState } from 'react';
import { Moon, Sun, Activity } from 'lucide-react';

const Header = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setIsDark(true);
      document.documentElement.classList.add('dark');
    }
  }, []);

  const toggleDarkMode = () => {
    setIsDark(!isDark);
    document.documentElement.classList.toggle('dark');
  };

  return (
    <header className="py-16 md:py-24">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-8 max-w-4xl">
          <div className="shrink-0 relative group">
            <div className="absolute inset-0 bg-trading-green/20 dark:bg-trading-neon/20 blur-2xl rounded-full group-hover:bg-trading-green/40 dark:group-hover:bg-trading-neon/40 transition-colors duration-700"></div>
            <img 
              src="/assets/trading-website-logo.png" 
              alt="Trading Resource Hub Logo" 
              className="relative w-20 h-20 md:w-28 md:h-28 rounded-3xl shadow-2xl border border-gray-200 dark:border-white/10 object-cover rotate-[-4deg] group-hover:rotate-0 transition-all duration-500 group-hover:scale-105"
            />
            {/* Status indicator */}
            <div className="absolute -bottom-2 -right-2 bg-white dark:bg-zinc-900 border border-gray-200 dark:border-white/10 rounded-full p-2 shadow-xl">
              <Activity className="w-5 h-5 text-trading-green dark:text-trading-neon" />
            </div>
          </div>
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-trading-green/10 dark:bg-trading-neon/5 border border-trading-green/20 dark:border-trading-neon/20 mb-4 backdrop-blur-sm">
              <span className="w-2 h-2 rounded-full bg-trading-green dark:bg-trading-neon animate-pulse shadow-[0_0_10px_rgba(16,185,129,0.5)] dark:shadow-[0_0_10px_rgba(204,255,0,0.5)]"></span>
              <span className="text-xs font-mono font-bold text-trading-green dark:text-trading-neon tracking-wider uppercase">u/EmergencyStation6855</span>
            </div>
            <h1 className="text-5xl md:text-7xl font-display font-extrabold text-gray-900 dark:text-white tracking-tighter mb-4 leading-[1.1]">
              Trading <br className="hidden md:block"/>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-500 to-gray-900 dark:from-white dark:to-gray-500">Resources</span> Hub
            </h1>
            <p className="text-lg md:text-xl text-gray-600 dark:text-gray-400 leading-relaxed font-medium max-w-2xl">
              A highly curated index of battle-tested <span className="text-gray-900 dark:text-white border-b-2 border-trading-green/50 dark:border-trading-neon/50 pb-0.5">books, tools, and channels</span>. Zero fluff. Straight to the point.
            </p>
          </div>
        </div>
        
        <button 
          onClick={toggleDarkMode}
          className="shrink-0 p-4 rounded-2xl bg-white/50 dark:bg-zinc-900/50 backdrop-blur-xl shadow-sm border border-gray-200 dark:border-gray-800 hover:border-trading-green/50 dark:hover:border-trading-neon/50 hover:shadow-[0_0_30px_rgba(16,185,129,0.15)] dark:hover:shadow-[0_0_30px_rgba(204,255,0,0.1)] transition-all duration-300 text-gray-900 dark:text-white group"
          aria-label="Toggle dark mode"
        >
          {isDark ? <Sun className="w-6 h-6 group-hover:rotate-45 transition-transform duration-500" /> : <Moon className="w-6 h-6 group-hover:-rotate-12 transition-transform duration-500" />}
        </button>
      </div>
    </header>
  );
};

export default Header;
